import { supabase } from '../lib/supabaseClient';

export const GALLERY_STORAGE_BUCKET = process.env.REACT_APP_GALLERY_BUCKET || 'gallery-media';
export const SITE_MEDIA_BUCKET = process.env.REACT_APP_SITE_MEDIA_BUCKET || 'site-media';
export const MAX_IMAGE_MB = 5;
export const MAX_VIDEO_MB = 20;

const buildPublicObjectPath = (folder, fileName) => `${folder}/${fileName}`;

const createFileName = (file, fallbackExt = 'bin') => {
  const extension = (file?.name?.split('.').pop() || fallbackExt).toLowerCase();
  return `${Date.now()}-${Math.random().toString(36).slice(2)}.${extension}`;
};

const uploadPublicFile = async ({ file, bucket, folder, maxSizeMb, allowedTypePrefix, fallbackExt }) => {
  if (!file) throw new Error('No file selected');
  if (!String(file.type || '').startsWith(allowedTypePrefix)) {
    throw new Error(`Only ${allowedTypePrefix.replace('/', '')} files are allowed`);
  }
  if (file.size > maxSizeMb * 1024 * 1024) {
    throw new Error(`File is too large. Max ${maxSizeMb}MB.`);
  }

  const fileName = createFileName(file, fallbackExt);
  const objectPath = buildPublicObjectPath(folder, fileName);
  const { error: uploadError } = await supabase.storage
    .from(bucket)
    .upload(objectPath, file, {
      cacheControl: '3600',
      upsert: false,
      contentType: file.type || undefined
    });

  if (uploadError) throw uploadError;
  const { data } = supabase.storage.from(bucket).getPublicUrl(objectPath);
  return data?.publicUrl || '';
};

export const uploadImageToSiteMedia = async (file, folder) =>
  uploadPublicFile({
    file,
    bucket: SITE_MEDIA_BUCKET,
    folder,
    maxSizeMb: MAX_IMAGE_MB,
    allowedTypePrefix: 'image/',
    fallbackExt: 'jpg'
  });

export const uploadImageToGalleryMedia = async (file, folder = 'gallery-images') =>
  uploadPublicFile({
    file,
    bucket: GALLERY_STORAGE_BUCKET,
    folder,
    maxSizeMb: MAX_IMAGE_MB,
    allowedTypePrefix: 'image/',
    fallbackExt: 'jpg'
  });

export const uploadVideoToGalleryMedia = async (file, folder = 'gallery-videos') =>
  uploadPublicFile({
    file,
    bucket: GALLERY_STORAGE_BUCKET,
    folder,
    maxSizeMb: MAX_VIDEO_MB,
    allowedTypePrefix: 'video/',
    fallbackExt: 'mp4'
  });
